import React from 'react';
import Popover from 'material-ui/Popover';
import classNames from 'classnames';
import './HelpLink.styl';

export default class HelpLink extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  showHelp = () => {
    this.setState({showHelp: true});
  };

  hideHelp = () => {
    this.setState({showHelp: false});
  };

  render() {
    const popoverClassName = classNames('help-popover', this.props.popoverClassName);
    return (
      <div>
        <button
          className="admin-help-link generic-link"
          onMouseEnter={this.showHelp}
          onMouseLeave={this.hideHelp}
          ref={ref => (this.helpRef = ref)}>
          Help
        </button>
        {this.state.showHelp && (
          <Popover
            open={true}
            className={popoverClassName}
            canAutoPosition={false}
            useLayerForClickAway={false}
            anchorEl={this.helpRef}
            anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
            targetOrigin={{horizontal: 'right', vertical: 'top'}}>
            {this.props.children}
          </Popover>
        )}
      </div>
    );
  }
}
